import http from "../utils/http-common";

const downloadReport = (suiteId: number, reportType: string) => {
  return http.post(
    `/report/download`,
    { suiteId, reportType },
    {
      responseType: reportType === "all" ? "arraybuffer" : "text",
    }
  );
};
const downloadCaseReport = (caseId: number) => {
  return http.get(`/report/download/${caseId}`, {
    responseType: "arraybuffer",
  });
};

const getCaseReportStructure = (caseId: number) => {
  return http.get(`/report/structure/${caseId}`);
};
const getCaseReportFile = (caseId: number, path: string) => {
  return http.get(`/report/structure/${caseId}/file`, {
    params: { path },
  });
};
const getReportAnalytics = () => {
  return http.get(`/report/analytics`);
};
const getAllureSingleReport = (
  userId: number,
  suiteId: number,
  caseId: number
) => {
  return http.post(`/report/allure/single-report`, {
    userId,
    suiteId,
    caseId,
  });
};
const getAllureGeneralReport = (
  suiteId: number,
  userId: number,
  regenerate: boolean
) => {
  return http.post(`/report/allure/general-report`, {
    suiteId,
    userId,
    regenerate,
  });
};

const reportService = {
  downloadReport,
  downloadCaseReport,
  getCaseReportStructure,
  getCaseReportFile,
  getReportAnalytics,
  getAllureSingleReport,
  getAllureGeneralReport,
};

export default reportService;
